import {Component} from '@angular/core';
import {UserStatisticsFilesComponent} from '../user-statistics-files/user-statistics-files.component';

@Component({
    selector: 'app-master-stats',
    standalone: true,
    imports: [UserStatisticsFilesComponent],
    templateUrl: './master-stats.component.html',
    styleUrl: './master-stats.component.css'
})
export class MasterStatsComponent {}
